import React from 'react';
import classNames from '../../utility/classNames';
import { format } from 'timeago.js';
import { Link } from 'react-router-dom';

export default function Notification({
  notification,
  markAsRead,
  position,
  deleteNotification,
}) {
  const {
    id,
    type,
    read,
    createdAt,
    senderName,
    senderEmail,
    recipientName,
    recipientEmail,
    propertyId,
  } = notification;
  const timeAgo = format(createdAt);
  const senderLabel =
    senderName && senderEmail
      ? `${senderName} (${senderEmail})`
      : senderName || senderEmail;

  const recipientLabel =
    recipientName && recipientEmail
      ? `${recipientName} (${recipientEmail})`
      : recipientName || recipientEmail;

  //the mark as read function is different for sharing notification since it needs to track the click
  const onNotificationClick = async () => {
    if (type === 'share') {
      markAsRead(id, notification.propertySharingUrl);

      window.open(`${notification.propertySharingUrl}`, '_blank');
    } else {
      if (!read) {
        await markAsRead(id);
      }
    }
  };

  return (
    <div
      className={classNames(
        'pl-5 pr-2 py-2 relative cursor-pointer font-normal',
        !read && 'bg-primary-50',
        position === 'middle' && 'border-t border-b border-gray-200',
        // position === 'top' && 'rounded-t-lg',
        position === 'bottom' && 'rounded-b-lg'
      )}
      onClick={onNotificationClick}
      tabIndex={0}
    >
      {type === 'share' && (
        <div className="grid grid-cols-3 w-full">
          <div className="col-span-2 flex flex-col justify-between gap-2">
            <div className="text-base text-neutral-800 break-words">
              <span className="font-semibold break-all">{senderLabel}</span>{' '}
              shared a property with you. Click to view.
            </div>
            <div
              className="text-sm text-gray-500 flex items-center gap-2"
              onClick={(e) => e.stopPropagation()}
            >
              <span>{timeAgo}</span>
              <button
                type="button"
                className="underline hover:text-primary focus:text-primary"
                onClick={() => deleteNotification(id)}
              >
                Dismiss
              </button>
            </div>
          </div>
          <div className="col-span-1 flex justify-end items-center">
            {notification.propertyCoverImageUrl && (
              <img
                src={notification.propertyCoverImageUrl}
                className="-my-1 -mr-4 h-16 max-w-[100px] rounded object-cover"
              />
            )}
          </div>
        </div>
      )}
      {type === 'viewed' && (
        <div className="grid grid-cols-3 w-full">
          <div className="col-span-3 flex flex-col justify-between gap-2">
            <div className="text-base text-neutral-800 break-words">
              <span className="font-semibold break-all">{recipientLabel}</span>{' '}
              viewed the{' '}
              <Link
                to={`/properties/${propertyId}`}
                className="text-primary-600 underline"
              >
                property
              </Link>{' '}
              you shared with them!
            </div>
            <div
              className="text-sm text-gray-500 flex items-center gap-2"
              onClick={(e) => e.stopPropagation()}
            >
              <span>{timeAgo}</span>
              <button
                type="button"
                className="underline hover:text-primary focus:text-primary"
                onClick={() => deleteNotification(id)}
              >
                Dismiss
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
